import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { RewardPreview } from '@/shared/ui/rewardPreview'
import { useStyles } from './styles'
import { HardWareGiveaway } from '@/shared/ui/hardwareGiveaway'

const mockPointsForCityHolder = [
  { amountOfPoints: 30001, rarity: 1, kind: 0 },
  { amountOfPoints: 20001, rarity: 1, kind: 0 },
  { amountOfPoints: 10001, rarity: 1, kind: 0 },
]

export const UniqueCaseReward = ({ caseName }: { caseName: string }) => {
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.boxPage.uniqueContent
  const ps5Texts = lang[userLang].pages.dailyBonus

  const folder = caseName?.replace(/\s/g, '').toLowerCase()
  const { classes } = useStyles()
  if (caseName === 'City Holder Case') {
    return (
      <>
        <p className={classes.heading}>{texts.title}</p>
        <div className={classes.ambassadorRewardListWrapper}>
          {mockPointsForCityHolder.map((i) => (
            <RewardPreview
              amountOfPoints={i.amountOfPoints}
              boxName={folder}
              text={texts.cityHolder.title}
              rarity={1}
              kind={0}
            />
          ))}
        </div>
      </>
    )
  }
  if (caseName === 'PS 5 Limited Case') {
    return (
      <HardWareGiveaway
        heading={ps5Texts.farcana.hardwareHeading}
        description={ps5Texts.farcana.hardwareDescription}
        img="/assets/backgrounds/playstationWithPack.webp"
        headingStyles={{ fontSize: '20px' }}
        justifyContent="space-between"
        gap={4}
        minHeight={120}
        maxHeight={150}
        height={'auto'}
      />
    )
  }

  if (caseName === 'KHALID Case') {
    return (
      <div className={classes.halidUniqueRewardsWrapper}>
        <HardWareGiveaway
          heading={'AK-47 Legion of Anubis'}
          description={''}
          img={'https://storage.googleapis.com/gamed-games-bucket/pictures/cases-and-rewards/halid-rewards/AK.webp'}
          headingStyles={{ fontSize: '24px' }}
          justifyContent="space-between"
          gap={4}
          minHeight={128}
          maxHeight={128}
          height={128}
        />
        <HardWareGiveaway
          heading={'Steam Voucher (10 USD)'}
          description={''}
          img={'https://storage.googleapis.com/gamed-games-bucket/pictures/cases-and-rewards/halid-rewards/Vouchers.webp'}
          headingStyles={{ fontSize: '24px' }}
          justifyContent="space-between"
          gap={12}
          minHeight={128}
          maxHeight={128}
          height={128}
          borderColor="rgba(74, 107, 252, 1)"
        />
      </div>
    )
  }
}
